import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { getRecentNewsTable } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/recentNews',
  initialState: {
    isLoading: true,
    ids: [],
    data: {},
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.ids = []
      state.data = {}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRecentNewsTable.pending, (state) => {
      state.isLoading = true
      state.ids = []
      state.data = {}
    })
    builder.addCase(getRecentNewsTable.fulfilled, (state, { payload = [] }) => {
      state.isLoading = false
      state.ids = payload.map((item) => item.id)
      state.data = keyBy(payload, 'id')
    })
    builder.addCase(getRecentNewsTable.rejected, (state, { payload = {} }) => {
      state.isLoading = payload.isLoading
    })
  },
})

export const selectIds = (state) => state[slice.name].ids
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectRecentNewsItem = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
